import React from "react";
import { Card } from "@nextui-org/react";

const FeatureVideoCard = ({
  videoUrl,
  title,
  description,
  videoOnLeft = true, // default left
}) => {
  return (
    <Card className={`flex bg-transparent ${videoOnLeft ? "flex-row" : "flex-row-reverse"} max-w-5xl gap-x-24 shadow-none`}>
      {/* Video content */}
      <div className="flex w-1/2 justify-center">
        <div className="h-[320px] w-[460px] overflow-hidden rounded-[30px]">
          <video
            loop
            muted
            autoPlay
            className="h-full w-full" // The video will be as large as the container
            style={{
              // This style will position the video to the center
              objectFit: "cover",
              objectPosition: "center",
            }}
          >
            <source src={videoUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>

      {/* Text content with inline style for the 50px gap */}
      <div className="flex w-1/2 flex-col justify-center text-left">
        <h3 className="pb-8">{title}</h3>
        <h5 className="max-w-sm">{description}</h5>
      </div>
    </Card>
  );
};

export default FeatureVideoCard;
